//#region src/auto_add_scannable_items_mode.ts
var AutoAddScannableItemsMode = /* @__PURE__ */ function(AutoAddScannableItemsMode) {
	AutoAddScannableItemsMode["No"] = "no";
	AutoAddScannableItemsMode["PricedItems"] = "priced-items";
	AutoAddScannableItemsMode["AllItems"] = "all-items";
	return AutoAddScannableItemsMode;
}(AutoAddScannableItemsMode || {});
//#endregion
export { AutoAddScannableItemsMode };

//# sourceMappingURL=auto_add_scannable_items_mode.js.map